import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

import greedyHiya from './greedyHiya'
import LockySlot from './luckySlot'
import greedyBox from './greedyBox'
import luckyWheel from './luckyWheel'
import bigWheel from './bigWheel'
import sinbad from './sinbad'

export default [
  {
    path: '/game/freeIndex',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-freeIndex" */ '~/pages/game/FreeIndex'
        )
    ),
  },
  // 广播列表
  {
    path: '/broadCast',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-broadCast" */ '~/pages/game/BroadCast'
        )
    ),
  },
  ...greedyHiya,
  ...LockySlot,
  ...greedyBox,
  ...luckyWheel,
  ...bigWheel,
  ...sinbad,
] as RouteConfig[]
